module.exports = __webpack_public_path__ + "img/Group 10089.204dc681.svg";